(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row-play/assets/javascripts/animations/core.js') >= 0) return;  svs.modules.push('/components/tur/ball-row-play/assets/javascripts/animations/core.js');

'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.play = svs.tur.ball.row.play || {};
svs.tur.ball.row.play.animations = svs.tur.ball.row.play.animations || {};
class Core {
  update(ball, number) {
    const tl = gsap.timeline();
    tl.to(ball.$el, {
      duration: 0.1,
      scale: 0.8,
      rotation: _.random(-120, 120)
    });
    tl.call(() => {
      ball.setNumber(number);
    });
    tl.to(ball.$el, {
      duration: 0.2,
      scale: 1,
      rotation: 0,
      ease: 'back.out',
      clearProps: 'all'
    });
    return tl;
  }
  clear(ball) {
    const tl = gsap.timeline();
    tl.to(ball.$number, {
      duration: 0.3,
      scale: 0,
      opacity: 0,
      rotation: 90
    });
    tl.call(() => {
      ball.clearNumber();
    });
    tl.set(ball.$number, {
      clearProps: 'all'
    });
    return tl;
  }
  remove(ball) {
    const tl = gsap.timeline();
    tl.to(ball.$el, {
      duration: 0.3,
      width: 0,
      scale: 0,
      opacity: 0
    });
    tl.call(() => {
      ball.remove();
    });
    return tl;
  }
}
svs.tur.ball.row.play.animations.Core = new Core();

 })(window);